let inject = ['$q', '$http', 'ngAuthSettings', 'AuthTokenFactory', 'SharedService', 'SessionService'];

class ShoppingExperienceService {
    constructor($q, $http, ngAuthSettings, AuthTokenFactory, SharedService, SessionService) {
        this.$q = $q;
        this.$http = $http;
        this.ngAuthSettings = ngAuthSettings;
        this.AuthTokenFactory = AuthTokenFactory;
        this.SharedService = SharedService;
        this.SessionService = SessionService;
    }

    sendExperienceComment(data) {
        return this.$q((resolve, reject) => {
            this.$http({
                method: 'POST',
                url: this.ngAuthSettings.apiServiceBaseUri + this.ngAuthSettings.config.paths.experienceComment,
                data: $.param(data),
                headers: {'Content-Type': 'application/x-www-form-urlencoded'},
                cache: false
            }).then(function (response) {
                resolve(response.data);
            }, function (reason) {
                reject(reason);
            });
        });
    }


}

ShoppingExperienceService.$inject = inject;

export default ShoppingExperienceService;



// WEBPACK FOOTER //
// ./www/components/shopping-experience/shopping-experience.service.js